import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {Distribution} from './../../distributions/distribution';
import {TestDistribution} from './test-distribution';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.FitDistribution
 */
export interface FitDistribution extends Computation._UnivariateComputation {
    distribution: Distribution;
    test: boolean;

    // PolyJson type
    type: 'fit_distribution';
}

export function isFitDistribution(toTest: Computation): toTest is FitDistribution { return 'fit_distribution' === toTest.type; }

export namespace FitDistribution {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.FitDistribution$FitDistributionResult
     */
    export interface FitDistributionResult extends _AvailableResult {
        fit: Distribution.FittedDistribution;
        test?: TestDistribution.TestDistributionResult | null;

        // PolyJson type
        type: 'fit_distribution';
    }

    export function isFitDistributionResult(toTest: ComputationResult): toTest is FitDistributionResult { return 'fit_distribution' === toTest.type; }
}